'use-strict';

/* eslint no-console: "off" */
const logger = () => next => action => {
  if (process.env.NODE_ENV !== 'production') console.log(action);
  return next(action);
};

export default logger;
